import React from 'react';
import PropTypes from 'prop-types';

import { icons } from '../../assets/assets';

class GroupRow extends React.Component {
  static propTypes = {
    text: PropTypes.string,
    color: PropTypes.string,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    saved: PropTypes.bool,
  };
  static defaultProps = {
    text: '',
    color: 'red',
    disabled: false,
    onClick: () => {},
    saved: false,
  };

  render() {
    const { text, color, disabled, onClick, saved } = this.props;
    const disabledClass = disabled ? ' disabled' : '';
    return (
      <div onClick={onClick} className={`group-row ${color}${disabledClass}`}>
        <div className={'ranking-row-inner'}>
          <span>{text}</span>
          {saved ? (
            <img style={{ height: '20px', marginRight: '10px' }} src={icons.check} alt="checked" />
          ) : null}
        </div>
      </div>
    );
  }
}

export default GroupRow;



// WEBPACK FOOTER //
// ./src/components/elements/GroupRow.js